export const json = {
  locale: 'en_us',
  recipe: "Recipe",
  machine: "Machine",
  task: {
    state: {
      unset: "Unset",
      todo: "To Do",
      in_progress: "In Progress",
      to_test: "To Test",
      wont_fix: "Won't fix",
      done: "Done",
      paused: "Paused",
    },
    priority: {
      unset: "No Priority",
      low: "Low",
      normal: "Normal",
      high: "High",
      max: "Urgent",
    },
    table: {
      header: {
        title: "Task",
        state: "State",
        priority: "Priority",
        labels: "Labels",
        createdAt: "Created",
        updatedAt: "Updated"
      },
      placeholder: {
        filter: {
          priority: "Filter emails...",
        },
      },
      "no-results": "No Results",
    },
    add: {
      title: "Add New Task",
      name: "Task Name",
      name_placeholder: "Enter task name",
      priority: "Priority",
      title_translations: "Title Translations",
      description_translations: "Description Translations",
      icon_url: "Icon URL (optional)",
      icon_url_placeholder: "Enter icon URL",
      labels: "Labels",
      assigned_to: "Assigned To",
      assigned_to_placeholder: "Select moderator",
      submit: "Create Task",
      cancel: "Cancel",
      edit_translations: "Edit Translations",
      save_translations: "Save Translations",
      required_field: "This field is required",
      en_us_required: "English (US) translation is required",
      success: "Task created successfully!",
      error: "Error creating task. Please try again.",
    },
  },
  table: {
    select: {
      of: "of",
      rows: "row(s) selected.",
    },
  },
  cookies: {
    link: 'Cookie Policy',
    title: "Cookie Consent",
    description:
      "This website uses cookies to ensure its proper functioning and to enhance your experience. Please select which cookies you allow us to use.",
    policy_link: "Learn more in our Cookie Policy",
    accept_all: "Accept All",
    accept_selected: "Accept Selected",
    accept_essential: "Essential Only",
    manage: "Manage Preferences",
    save: "Save Preferences",
    back: "Back",
    categories: {
      essential: {
        title: "Essential Cookies",
        description: "These cookies are necessary for the website to function and cannot be disabled.",
      },
      functional: {
        title: "Functional Cookies",
        description: "These cookies enable personalized features and functionality.",
      },
      analytics: {
        title: "Analytics Cookies",
        description: "These cookies help us understand how visitors interact with the website.",
      },
      marketing: {
        title: "Marketing Cookies",
        description: "These cookies are used to track visitors across websites for advertising purposes.",
      },
    },
    expiration: {
      title: "Cookie Expiration",
      description: "Choose how long your cookie preferences will be remembered:",
      thirty_days: "30 days",
      ninety_days: "90 days",
      six_months: "6 months",
      one_year: "1 year",
    },
    policy: {
      title: "Cookie Policy",
      introduction:
        "This Cookie Policy explains how we use cookies and similar technologies to recognize you when you visit our website. It explains what these technologies are and why we use them, as well as your rights to control our use of them.",
      what_are_cookies: "What are cookies?",
      what_are_cookies_text:
        "Cookies are small data files that are placed on your computer or mobile device when you visit a website. Cookies are widely used by website owners in order to make their websites work, or to work more efficiently, as well as to provide reporting information.",
      how_we_use: "How we use cookies",
      how_we_use_text:
        "We use cookies for several reasons. Some cookies are required for technical reasons in order for our website to operate, and we refer to these as 'essential' or 'necessary' cookies. Other cookies enable us to track and target the interests of our users to enhance the experience on our website. Third parties serve cookies through our website for advertising, analytics and other purposes.",
      types: "Types of cookies we use",
      managing: "Managing your cookies",
      managing_text:
        "You can set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our website though your access to some functionality and areas of our website may be restricted. As the means by which you can refuse cookies through your web browser controls vary from browser-to-browser, you should visit your browser's help menu for more information.",
      third_party: "Third-party cookies",
      third_party_text:
        "In addition to our own cookies, we may also use various third-party cookies to report usage statistics of the website, deliver advertisements on and through the website, and so on.",
      updates: "Updates to this Cookie Policy",
      updates_text:
        "We may update this Cookie Policy from time to time in order to reflect, for example, changes to the cookies we use or for other operational, legal or regulatory reasons. Please therefore re-visit this Cookie Policy regularly to stay informed about our use of cookies and related technologies.",
      purpose: "Purpose",
      essential_purpose:
        "Necessary for the website to function properly. These cookies enable basic functions like page navigation and access to secure areas of the website.",
      functional_purpose:
        "Allow the website to remember choices you make (such as your username, language or the region you are in) and provide enhanced, more personal features.",
      analytics_purpose:
        "Help us understand how visitors interact with our website by collecting and reporting information anonymously.",
      marketing_purpose:
        "Used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user.",
      always_active: "Always Active",
      active: "Active",
      inactive: "Inactive",
      back_to_site: "Back to Site",
    },
  },
  sidebar: {
    platform: "Platform",
    dashboard: "Dashboard",
    tasks: {
      title: "Tasks",
      add: "Add task"
    },
    analytics: "Analytics",
    users: "Users",
    settings: "Settings",
    admin_panel: {
      title: "Admin Panel",
      mods: {
        title: "Mods",
        add: "Add Mod"
      },
      labels: {
        title: "Labels",
        add: "Add Label"
      },
      pending: "Pending Approvals",
      flags: "Feature Flags",
      ratings: "Ratings"
    },
    documentation: {
      title: "Documentations",
      create: "Create Documentation"
    },
    search: "Search in docs..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "Overview",
          userInfo: 'User Information',
          userId: 'User ID',
          role: 'Role',
          memberSince: 'Member Since'
        },
        tasks: {
          title: 'Tasks',
          assigned: 'Assigned Tasks',
          noTasks: 'No tasks assigned yet.'
        },
        activity: {
          title: 'Activity',
          recent: 'Recent Activity',
          noActivity: 'No recent activity.'
        },
        settings: {
          title: 'Settings',
          user: 'User settings',
          admin: 'Admin settings for this user.'
        }
      }
    },
    mods: {
      error: {
        unknownError: "Unknown error"
      },
      access: {
        title: "Access Denied",
        description: "You don't have permission to access this page."
      },
      add: {
        link: "Add New Mod",
        title: "Add New Mod",
        addDesc: "Create a new mod entry",
        name: {
          title: "Name",
          placeholder: "Enter mod name"
        },
        description: {
          title: "Description",
          placholder: "Enter description in "
        },
        optional: "Optional",
        versions: {
          title: "Versions",
          add: "Add Version"
        },
        icon: "Icon URL",
        launchers: "Launchers",
        form: {
          errors: {
            alert: {
              title: "Error",
              description: "Please fix the errors above before submitting."
            },
            name: "Name is required",
            description: "English (US) description is required",
            curseforge: "CurseForge link is required",
            invalidURL: "Invalid URL format",
            versions: "At least one version is required",
            launchers: "At least one launcher is required"
          }
        },
        cancel: "Cancel",
        create: {
          loading: "Creating...",
          default: "Create Mod"
        },
        langDataError: "Error loading language data:",
      },
      noMods: "No mods found",
      getStarted: "Get started by creating a new mod.",
      fetch: {
        error: 'Error fetching documentation:'
      },
      "delete": {
        link: "Delete",
        confirm: "Are you sure you want to delete this mod?"
      },
      toast: {
        delete: {
          success: {
            title: "Mod deleted",
            description: "The mod has been deleted successfully."
          },
          error: {
            console: "Error deleting mod:",
            fallback: "Failed to delete mod",
            title: "Error",
            description: "An error occurred while deleting the mod."
          }
        },
        edit: {
          success: {
            title: "Success",
            description: "Mod updated successfully"
          }
        },
        add: {
          fallback: "Failed to create mod",
          success: {
            title: "Success",
            description: "Mod created successfully"
          },
          console: "Error creating mod:",
          error: {
            title: "Error",
            description: "Failed to create mod"
          }
        }
      },
      noDesc: "No description available",
      docs: {
        link: "Docs"
      },
      edit: {
        link: "Edit",
        title: "Edit Mod",
        langDataError: "Error loading language data:",
        notFound: "Mod not found",
        failFetch: "Failed to fetch mod",
        unknownError: "An unknown error occurred",
        form: {
          errors: {
            name: "Name is required",
            description: "English (US) description is required",
            curseforge: "CurseForge link is required",
            versions: "All version fields must be filled",
            launchers: "At least one launcher must be selected"
          }
        },
        modInfo: "Mod Information",
        editModInfo: "Edit the mods information.",
        name: "Name",
        description: {
          title: "Description",
          required: "English (US) description is required."
        },
        optional: "Optional",
        versions: {
          title: "Versions",
          add: "Add Version",
          remove: "Remove"
        },
        icon: "Icon URL",
        launchers: "Launchers",
        cancel: "Cancel",
        update: "Update Mod"
      }
    },
    docs: {
      access: {
        title: "Access Denied",
        description: "You don't have permission to access this page."
      },
      title: "Documentation",
      description: "Browse and read documentation for Minecraft mods",
      create: {
        link: "Create Documentation",
        tab: "Create New",
        content: {
          title: "No mods available",
          description: "All mods already have documentation or you don't have permission to create documentation for any mod."
        },
        title: "Create documentation"
      },
      published: "Published",
      pending: "Pending",
      noDocs: {
        title: "No documentation available",
        description: "There are no published documentation pages yet."
      },
      noPending: {
        title: "No pending documentation",
        superAdmin: "There are no documentation pages waiting for aproval",
        rest: "You don't have any pending documentation pages."
      },
      user: {
        noDocs: {
          title: "No documentation available",
          description: "There are no published documentation pages yet."
        }
      },
      card: {
        pending: "Pending Approval",
        view: "View",
        edit: "Edit"
      },
      add: {
        title: "Create New Documentation",
        description: "Create comprenhensive documentation for a Minecraft mod",
        noMods: {
          title: "No mods available",
          description: "There are no mods available for documentation creation. Either all mods already have documentation or you don't have permission to create documentation for any mod."
        },
        card: {
          title: "Basic Information",
          description: "provide basic information about the documentation.",
          descriptionLink: "View our documentation guide",
          content: {
            modSelect: "Select a mod",
            modSelectDesc: "Select the mod you want to create documentation for",
            noDesc: "No description available",
            form: {
              title: {
                title: "Title",
                placeholder: "Enter documentation title",
                description: "The title of your documentation (English US is required)"
              },
              description: {
                title: "Description",
                placeholder: "Enter documentation description",
                description: "A brief description of your documentation (English US is required)"
              },
              coverImage: {
                title: "Cover Image URL (Optional)",
                description: "Provide a URL for the cover image of your documentation"
              },
              tabs: {
                preview: {
                  title: "Preview",
                  content: {
                    title: "Preview",
                    description: "Preview your documentation will look",
                    form: {
                      title: "Documentation Title",
                      description: "Documentation description will appear here."
                    },
                    section: "section",
                    article: "article",
                    modSelect: {
                      title: "Select a mod",
                      description: "Select a mod to preview your documentation"
                    }
                  }
                },
                information: {
                  title: "Information",
                  content: {
                    title: "Information",
                    description: "Important Information about documentation creation",
                    approval: {
                      title: "Approval Required",
                      description: "Documentation created by edits and admins requirese approval from a super admin befor it becomes public. Open a ticket to request it."
                    },
                    after: {
                      title: "After Creation:",
                      list: {
                        one: "You'll be refirected to the documentation editor",
                        two: "A default section and article will be created automatically",
                        three: "You can add more sections and articles as needed",
                        four: "You can upload images and add custom components",
                        five: "You can preview your documentation before submitting for approval. (It needs to be saved before the preview)"
                      }
                    },
                    create: {
                      loading: "Creating...",
                      default: "Create Documentation"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "Failed to fetch mods",
          documentation: "Failed to fetch documentations"
        },
        success: {
          title: "Documentation Created",
          description: "Your documentation has been created successfully."
        },
        error: {
          fetching: {
            mods: {
              console: "Error fetching mods:",
              toast: {
                title: "Error",
                description: "Failed to load mods. Please try again."
              }
            }
          },
          creating: {
            failed: "Failed to create documentation",
            error: {
              console: "Error creating documentation:",
              toast: {
                title: "Error",
                description: "Failed to create documentation. Please try again."
              }
            }
          }
        }
      }
    }
  }
}
